import React, { useState } from 'react';
import { Button, Badge } from '@/components/ui';
import { 
  ForemanKpiGrid, 
  CategoryProgress,
  DailySchedule,
  SitePhotos,
  OverdueTasks,
  TeamPersonnel,
  MaterialUsage,
  EquipmentStatus,
  SiteAnnouncements,
  RecentDocuments,
  SafetyMetrics
} from './components';

export default function ForemanDashboardPage() {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div className="p-3 space-y-2 bg-slate-50/30 min-h-screen text-slate-800">
      {/* Header section manually reconstructed without Layout */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 px-1 mb-2">
        <div>
          <div className="flex items-center gap-2 text-xs font-medium text-slate-400 mb-1">
            <span>Dashboard</span>
            <i className="ri-arrow-right-s-line" />
            <span className="text-slate-600 font-bold">Tổ trưởng</span>
          </div>
          <div className="flex items-center gap-3">
            <h1 className="text-xl font-black text-slate-800">Bảng điều khiển Tổ trưởng</h1>
            <Badge variant="outline" className="bg-emerald-50 text-emerald-600 border-emerald-100 text-xs font-normal px-2 py-0.5 rounded-md">
              Field Foreman
            </Badge>
          </div>
          <p className="text-xs text-slate-400 mt-1 font-medium">Quản lý đội nhóm, phân công công việc và giám sát thi công tại hiện trường.</p>
        </div>

        <Button 
          variant="outline" 
          size="sm" 
          className="font-bold border-slate-200 text-slate-700 rounded-md h-9 px-3 gap-2"
          onClick={() => {}}
        >
          <i className="ri-refresh-line" />
          Làm mới
        </Button>
      </div>

      {/* KPI Section */}
      <ForemanKpiGrid isLoading={isLoading} />

      <div className="space-y-2">
        {/* Middle Section: 3-column layout */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-2">
          <CategoryProgress />
          <DailySchedule />
          <SitePhotos />
        </div>

        {/* Bottom Section: 4-column layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
          <OverdueTasks />
          <TeamPersonnel />
          <MaterialUsage />
          <EquipmentStatus />
        </div>

        {/* Bottom Section: 3-column layout */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-2">
          <SiteAnnouncements />
          <RecentDocuments />
          <SafetyMetrics />
        </div>
      </div>
    </div>
  );
}
